import { Table } from "antd";
import { FiEdit } from "react-icons/fi";
import Manage from "..";
import { useEffect, useState } from "react";
import UpdateUser from "./components/UpdateUser";
import CreateWrapper from "./components/CreateWrapper";
import UpdateApr from "./components/UpdateApr";
import fetchDataClaim from "../../../services/fetchDataClaim";
import UpdateCountry from "./components/UpdateCountry";
import UpdateScope from "./components/UpdateScope";

export default function AllCurrencies() {
  const [updateModal, setUpdateModal] = useState(false);
  const [countryModal, setCountryModal] = useState(false);
  const [scopeModal, setScopeModal] = useState(false);
  const [approverModal, setApproverModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [users, setUsers] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const handleFetchCurrencies = async () => {
    setLoading(true);
    const uri = "claim/controls/currencies";
    const response = await fetchDataClaim({ uri: uri });
    setUsers(response?.payload);
    setLoading(false);
  };

  useEffect(() => {
    handleFetchCurrencies();
  }, []);

  const columns = [
    {
      title: "S/N",
      width: 20,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "NAME",
      width: 50,
      render: (record: any) => (
        <span className="text-gray-700">{record?.name || "-"}</span>
      ),
    },
    {
      title: "RATE",
      width: 40,
      render: (record: any) => (
        <div className="flex items-center text-gray-700">
          <span>{record?.rate || "-"}</span>
        </div>
      ),
    },

    {
      title: "ACTION",
      width: 60,
      render: (record: any) => (
        <div className="flex items-center">
          <div className="flex mr-2">
            <button
              onClick={() => {
                setSelected({
                  ...record,
                });
                setUpdateModal(true);
              }}
              className="flex justify-center items-center text-gray-700 border rounded-md px-2 py-1 bg-yellow-100 hover:bg-yellow-200 cursor-pointer"
            >
              <FiEdit />
              <span className="ml-1">Edit</span>
            </button>
          </div>
          <div className="flex">
            {record?.canApprove ? (
              <button
                onClick={() => {
                  setSelected({
                    ...record,
                  });
                  setUpdateModal(true);
                }}
                className="flex justify-center items-center text-gray-700 border rounded-md px-2 py-1 bg-yellow-100 hover:bg-yellow-200 cursor-pointer"
              >
                <FiEdit />
                <span className="ml-1">Change Level</span>
              </button>
            ) : (
              <button
                onClick={() => {
                  setSelected({
                    ...record,
                  });
                  setApproverModal(true);
                }}
                className="flex justify-center items-center text-gray-700 border rounded-md px-2 py-1 bg-blue-100 hover:bg-blue-200 cursor-pointer"
              >
                <FiEdit />
                <span className="ml-1">Make Approver</span>
              </button>
            )}
          </div>
        </div>
      ),
    },
  ];

  return (
    <Manage
      title={"Currencies"}
      subtitle={"All"}
      description={"List of all currencies"}
      actions={<CreateWrapper refetch={handleFetchCurrencies} />}
    >
      <div className="grid gap-x-0 grid-cols-12">
        <div className="col-span-12 sm:col-span-12 md:col-span-12">
          <Table
            columns={columns}
            dataSource={users}
            size="small"
            pagination={{ pageSize: 20 }}
            scroll={{ y: 525 }}
            loading={isLoading}
            rowKey="id"
          />

          <UpdateUser
            selected={selected}
            isVisible={updateModal}
            setUpdateModal={setUpdateModal}
            refetch={handleFetchCurrencies}
          />

          <UpdateApr
            selected={selected}
            isVisible={approverModal}
            setVisible={setApproverModal}
            refetch={handleFetchCurrencies}
          />

          <UpdateCountry
            selected={selected}
            isVisible={countryModal}
            setVisible={setCountryModal}
            refetch={handleFetchCurrencies}
          />

          <UpdateScope
            selected={selected}
            isVisible={scopeModal}
            setVisible={setScopeModal}
            refetch={handleFetchCurrencies}
          />
        </div>
      </div>
    </Manage>
  );
}
